module.exports = __webpack_public_path__ + "img/clz.2c6e29ac.png";